import type { Route } from '~/core/router'

import * as root from '~/routes/shows/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.ShowsPage],
      init: root.model.init,
      left: root.model.left,
    },
  ],
}
